// @flow
import * as React from "react";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";

type Props = {|
  gameId: string,
  text?: string,
|};

function GameDetailsBuyTicket({ gameId, text, ...other }: Props) {
  const history = useHistory();

  return (
    <Button
      variant="contained"
      size="large"
      color="primary"
      onClick={() => history.push(`/ticket-reservation/${gameId}`)}
      startIcon={<ConfirmationNumberIcon />}
      {...other}
    >
      {text || "Jetzt Tickets reservieren"}
    </Button>
  );
}

export default GameDetailsBuyTicket;
